import React, { PureComponent } from 'react';
import { DLModal } from 'appSrc/components/Shards';
import { Icon } from 'appSrc/components/UI';
import { copyToClipboard } from 'appSrc/utils';
import style from './styles/style.module.css';



class ScheduledProsModal extends PureComponent {
    state = { msg: '' }
    copyToClipboard = () => {
        var msg = copyToClipboard( this._text );
        this.setState( { msg } );
    }
    componentDidUpdate( prevProps ) {
        if( prevProps.visible !== this.props.visible && !this.props.visible ) {
            this.setState( { msg: '' } );
        }
    }

    render() {
        const { pros } = this.props;
        const content = pros.map( p => p[ 1 ] ).filter( e => !!e ).join( ', ' );

        return (
            <DLModal title='Scheduled Pros' className={ style.prosModal }
            closeHandler={ this.props.closeHandler } visible={ this.props.visible }>
                <div className={ style.content }>
                    <table>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Email</th>
                            </tr>
                        </thead>
                        <tbody>
                            { pros.map( pro => (
                                <tr key={ pro[ 0 ] }>
                                    <td>{ pro[ 0 ] }</td>
                                    <td>{ pro[ 1 ] }</td>
                                </tr>
                            ) ) }
                        </tbody>
                    </table>
                    <div className={ style.copySection }>
                        <div className={ style.copyWrapper }>
                            <p className={ style.clickable } onClick={ this.copyToClipboard }>
                                <Icon source='fontAwesome' icon='fas/faCopy' />Copy emails to clipboard
                            </p>
                            <p>{ this.state.msg }</p>
                            <textarea className={ style.almostInvisible }
                            ref={ ( el ) => { this._text = el; } }
                            defaultValue={ content }></textarea>
                        </div>
                    </div>
                </div>
            </DLModal>
        );
    }
}
ScheduledProsModal.defaultProps = {
    onSubmit: () => {},
    pros: [],
};

export default ScheduledProsModal;
